/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import {
  HeaderTitle,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
} from '../../../services/settings/appStyle/global.style';

import { Loader, Table } from '../../../Components/uielements';
import { useUserContext } from '../../../hooks/UserContext';
import { useCompany } from '../../../hooks/CompanyContext';
import PremiseService from '../../../services/bioplus-services/premise';
import { CompanyContainer } from './premise.style';
import { IntlMessages } from '../../../helper/langHelper';

const CorporateAdminPremise = () => {
  const userContext = useUserContext();
  const companyContext = useCompany();

  const parentId = userContext?.company?.companyId;
  const companyFilter = companyContext?.company?._id;
  const [nameFilter, setNameFilter] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const query = useQuery(['premises', parentId, companyFilter, nameFilter, page, pageSize], () =>
    PremiseService.listByParent(
      parentId,
      { companyId: companyFilter, name: nameFilter },
      page,
      pageSize
    )
  );
  const tableData = query?.data?.items ?? [];

  //   table coulmns
  const userColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.premise.name" />,
        accessor: 'propertyName',
        Cell: (cellData) => <TableCell>{cellData.value}</TableCell>,
        width: '20%',
      },
      {
        Header: <IntlMessages id="table.col.region" />,
        accessor: 'addressState',
        width: '20%',
      },
      {
        Header: <IntlMessages id="table.col.parent.company" />,
        accessor: 'companyName',
        width: '20%',
      },
      // {
      //   Header: <IntlMessages id="table.col.managers" />,
      //   accessor: 'managerCount',
      // },
      {
        Header: <IntlMessages id="table.col.alert.receivers" />,
        accessor: 'alertReceiverCount',
        width: '20%',
      },
    ],
    []
  );

  if (query.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="nav.premises" />
        </HeaderTitle>
      </CompanyContainer>
      <TableWrapper>
        <Table data={tableData} columns={userColumns} hasFooter={false} />
      </TableWrapper>
    </StyledContainer>
  );
};

export default CorporateAdminPremise;
